import store from "../redux/store";
import axios from 'axios';
import { constHostAddressConfig } from './constData';
// 067C001242/123456
const axiosClient = axios.create({
    baseURL: constHostAddressConfig.ApiOrderAdress,
    // baseURL: 'http://localhost:52959/',
    // baseURL: 'http://192.168.2.23:6788/',
    // baseURL: 'https://prio.navisoft.com.vn/',
    headers: {
        'Content-Type': 'application/json',
    }
})
 
export const login = (username, password) => {
    return axiosClient.post('/HomeMobile/Login', {
        userName: username,
        password: password
    });
};

export const logout = () => {
    const token = store.getState().gUser.token;
    return axiosClient.post('/HomeMobile/LogOff', {
        ticket: token
    });
};

export const checkLoginState = (token) => {
    return axiosClient.post('/HomeMobile/CheckLoginState', {
        Ticket: token
    });
};

export const executeNormalOrder = (jsonData) => {
    return axiosClient.post('/OrderMobile/OrderExcute', jsonData);
}

export const executeEditOrder = (jsonData) => {
    return axiosClient.post('/OrderMobile/EditOrder', jsonData);
}

export const executeCancelOrder = (jsonData) => {
    return axiosClient.post('/OrderMobile/CancelOrder', jsonData);
}

export const executeConditionalOrder = (jsonData) => {
    return axiosClient.post('/OrderMobile/LenhDieuKienSubmit', jsonData);
}

export const executeCancelConditionalOrder = (jsonData) => {
    return axiosClient.post('/OrderMobile/CancelOrder', jsonData);
}

export const getAccTnoDetail = (jsonData) => {
    return axiosClient.post('/HomeMobile/GetAccTnoDetail', jsonData);
}

export const getAccTnoDetailOrder = (jsonData) => {
    return axiosClient.post('/OrderMobile/getCanBuyQttSucmua', jsonData);
}

export const getOrderBook = (jsonData) => {
    return axiosClient.post('/OrderMobile/GetListOrderAction', jsonData);
}

export const getConditionalOrderBook = (jsonData) => {
    return axiosClient.post('/OrderMobile/LenhDieuKienSearch', jsonData);
}

export const getAssetStockInfo = (jsonData) => {
    return axiosClient.post('/AssetsMobile/GetStockInfo', jsonData);
}

export const getAssetCashInfo = (jsonData) => {
    return axiosClient.post('/AssetsMobile/GetCashInfo', jsonData);
}

export const getNotifyInfo = (jsonData) => {
    return axiosClient.post('/NotifyMobile/GetNotifyAction', jsonData);
}
export const getFillPrice = (jsonData) => {
    return axiosClient.post('/OrderMobile/KRX_GetSecurities', jsonData);
}